import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

interface SetupCheckResponse {
  has_platform_admin: boolean;
  admin_count: number;
}

export default function RootRedirect() {
  const { t } = useTranslation('common');
  const [isLoading, setIsLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);

  useEffect(() => {
    const checkSetup = async () => {
      try {
        const response = await fetch('/api/v1/admin/setup/check', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data: SetupCheckResponse = await response.json();
          if (!data.has_platform_admin) {
            setNeedsSetup(true);
          }
        }
      } catch {
        // If check fails, proceed to normal flow
        // eslint-disable-next-line no-console
        console.error('Setup check failed');
      } finally {
        setIsLoading(false);
      }
    };

    checkSetup();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-surface-light dark:bg-surface-dark flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600 mx-auto"></div>
          <p className="mt-4 text-text-muted-light dark:text-text-muted-dark">
            {t('actions.loading')}
          </p>
        </div>
      </div>
    );
  }

  if (needsSetup) {
    return <Navigate to="/admin/setup" replace />;
  }

  return <Navigate to="/home" replace />;
}
